import { Box, Tab, Tabs } from '@mui/material';
import { UsersListType } from '@okletsplay/core';
import { Route } from 'app/enums';
import users_banner from 'assets/images/app_active-users_banner.jpg';
import { debounce } from 'lodash';
import { PlayersList } from 'modules/users/components/PlayersList';
import React, { ChangeEvent, FC, SyntheticEvent, useCallback, useState } from 'react';
import {
  Route as ReactRoute,
  Routes as ReactRoutes,
  useNavigate,
  useMatch,
  useLocation,
  Navigate,
} from 'react-router-dom';
import { PageBanner } from 'shared/components/PageBanner';
import { SearchInput } from 'shared/components/SearchInput';
import { useStyles } from './PlayersPage.styles';

const PlayersPage: FC = () => {
  const { classes } = useStyles();

  const matchPlayersOnline = useMatch({ path: Route.PlayersRecentlyPlayed });
  const navigate = useNavigate();
  const [search, setSearch] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const loadingStartHandler = useCallback(() => setLoading(true), []);
  const loadingEndHandler = useCallback(() => setLoading(false), []);
  const { pathname } = useLocation();

  const changeSearchHandler = debounce(
    (event: ChangeEvent<HTMLInputElement>) => setSearch(event?.target?.value),
    300
  );

  const selectTab = useCallback(
    (event: SyntheticEvent, tab: number) =>
      navigate(tab === 0 ? Route.PlayersOnline : Route.PlayersRecentlyPlayed),
    [navigate]
  );

  if (pathname === Route.Players) {
    return <Navigate to={Route.PlayersOnline} />;
  }

  return (
    <Box className={classes.root}>
      <PageBanner url={users_banner} title="Players Online" text="Living loot bags." />
      <Box className={classes.tabsPanel}>
        <Tabs value={matchPlayersOnline ? 1 : 0} onChange={selectTab}>
          <Tab disableRipple label="All Players" />
          <Tab disableRipple label="Recently Played With" />
        </Tabs>
        <SearchInput
          placeholder="Search for players..."
          onChange={changeSearchHandler}
          className={classes.search}
          loading={loading && Boolean(search)}
        />
      </Box>
      <Box className={classes.listContainer}>
        <ReactRoutes>
          <ReactRoute
            path="/online"
            element={
              <PlayersList
                type={UsersListType.All}
                search={search}
                onLoadingStart={loadingStartHandler}
                onLoadingEnd={loadingEndHandler}
              />
            }
          />
          <ReactRoute
            path="/recently-played"
            element={
              <PlayersList
                type={UsersListType.RecentlyPlayed}
                search={search}
                onLoadingStart={loadingStartHandler}
                onLoadingEnd={loadingEndHandler}
              />
            }
          />
        </ReactRoutes>
      </Box>
    </Box>
  );
};

export default PlayersPage;
